<div class="consultar-fornecedor-container">
  <div class="header">
    <h1>Consultar Fornecedor</h1>
    <button type="button" class="btn btn-primary" (click)="novo()">
      <i class="fa fa-plus"></i> Adicionar novo
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3 align-items-end">
      <div class="col-md-2">
        <label class="form-label">Código</label>
        <input type="number" class="form-control" [(ngModel)]="filtroCodigo" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Nome</label>
        <input type="text" class="form-control" [(ngModel)]="filtroNome" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Razão Social</label>
        <input type="text" class="form-control" [(ngModel)]="filtroRazaoSocial" />
      </div>
      <div class="col-md-2">
        <label class="form-label">CNPJ</label>
        <input type="text" class="form-control" [(ngModel)]="filtroCnpj" />
      </div>
      <div class="col-md-2">
        <label class="form-label">CPF</label>
        <input type="text" class="form-control" [(ngModel)]="filtroCpf" />
      </div>

      <div class="col-md-3">
        <label class="form-label">Status</label>
        <select class="form-control" [(ngModel)]="filtroIdFinStatusFornecedor">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let item of statusFornecedor" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Ativo</label>
        <select class="form-control" [(ngModel)]="filtroAtivo">
          <option value="">Todos</option>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
      <div class="col-md-7 text-end">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar
        </button>
        <button type="button" class="btn btn-primary" (click)="buscar()">
          <i class="fa fa-search"></i> Buscar
        </button>
      </div>
    </div>
  </div>

  <div class="card-box">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nome</th>
            <th>Razão Social</th>
            <th>CNPJ</th>
            <th>CPF</th>
            <th>Ativo</th>
            <th>Telefone 1</th>
            <th>Email 1</th>
            <th>CID</th>
            <th>Centro de Custos</th>
            <th>Status</th>
            <th style="width: 150px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itensPaginados">
            <td>{{ item.codigo || '-' }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.razaoSocial || '-' }}</td>
            <td>{{ item.cnpj || '-' }}</td>
            <td>{{ item.cpf || '-' }}</td>
            <td>{{ item.ativo ? 'Sim' : 'Não' }}</td>
            <td>{{ item.telefone1 || '-' }}</td>
            <td>{{ item.email1 || '-' }}</td>
            <td>{{ item.cid || '-' }}</td>
            <td>{{ item.centroCusto || '-' }}</td>
            <td>{{ item.finStatusFornecedor || '-' }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-warning me-1" (click)="editar(item)" title="Editar">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="deletar(item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && itens.length === 0">
            <td colspan="12" class="text-center text-muted py-3">Nenhum fornecedor encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3" *ngIf="itens.length > 0">
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Itens por página:</label>
        <select class="form-control form-control-sm per-page" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
          Anterior
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
          Próxima
        </button>
      </div>
    </div>
  </div>
</div>
